import { useMutation } from '@tanstack/vue-query'
import { downloadBlob } from '@shared/utils'
import { downloadTransactions } from './transactionEndpoints'
import type { DownloadFormat, TransactionFilters } from '../types/transactionTypes'

const ISO_DATE_LENGTH = 10

const buildStatementFileName = (format: DownloadFormat): string => {
  const extension = format === 'excel' ? 'xlsx' : 'csv'
  const today = new Date().toISOString().slice(0, ISO_DATE_LENGTH).replace(/-/g, '')
  return `Sliceal_Transaction_Statement_${today}.${extension}`
}

export function useDownloadTransactionsMutation() {
  return useMutation({
    mutationFn: ({ format, filters }: { format: DownloadFormat; filters: TransactionFilters }) =>
      downloadTransactions(format, filters),
    onSuccess: (blob, { format }) => {
      downloadBlob(blob, buildStatementFileName(format))
    },
  })
}
